import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    createTitle: 'Quote creation',
    ctaPrimary: 'Validate the quote',
    delete: 'Delete',
    editTitle: 'Quote edition',
    error:
      'Your quote contains errors. Check the information in the incorrect fields.',
    help: 'Help',
    save: 'Save',
  },
  fr: {
    createTitle: 'Création du devis',
    ctaPrimary: 'Valider le devis',
    delete: 'Supprimer',
    editTitle: 'Édition du devis',
    error:
      'Votre devis contient des erreurs. Vérifiez les informations des champs erronés.',
    help: 'Aide',
    save: 'Enregistrer',
  },
} as const);

export default locales;
